import React from "react";
import { AppBar, Toolbar, IconButton, Hidden, Typography, Grid, Popover, makeStyles } from "@material-ui/core";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ArrowBack from "@material-ui/icons/ArrowBackIos";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

import { UserAvatar } from "../../components/UserAvatar";
import { ApplicationUser } from "../../entities/ApplicationUser";

const useStyles = makeStyles((theme) => ({
	container: {
		background: "#efefef",
	},
	appBar: {
		color: "#6b6b6b",
		background: "#FFFFFF",
		boxShadow: "unset",
		paddingTop: "4px",
	},
	grow: {
		flex: 1,
	},
	fontSizingWrapper: {
		display: "flex",
		padding: "7px 15px",
	},
	fontPrecentage: {
		padding: "5px 10px",
		fontWeight: "bolder",
	},
	buttonIcon: {
		padding: 5,
	},
	title: {
		whiteSpace: "nowrap",
		overflow: "hidden",
		width: "100%",
		textOverflow: "ellipsis",
	},
	timerIcon: {
		color: "#FFF",
		fontSize: 25,
		paddingTop: 3,
	},
	popOverContainer: {
		paddingRight: 15,
		height: "40px",
	},
	mr15: {
		marginRight: 15,
	},
	hiddenTitleContainerMdUp: {
		flexGrow: 1,
		width: "50%",
	},
	hiddenTitleContainerMdDown: {
		flexGrow: 1,
	},
}));

interface Props {
	onSignOut: () => void;
	onSignIn: (user: ApplicationUser) => void;
	setAnchorElFont: (anchorElFont: HTMLElement | undefined) => void;
	increaseFontSize: (e: React.MouseEvent<HTMLElement>) => void;
	decreaseFontSize: (e: React.MouseEvent<HTMLElement>) => void;
	onGoBack: () => void;
	user: ApplicationUser;
	title: string;
	anchorElFont: HTMLElement | undefined;
	fontSize: number;
}

export function PresenterAppBar(props: Props) {
	const { title, anchorElFont, fontSize } = props;
	const { setAnchorElFont, decreaseFontSize, increaseFontSize, onGoBack } = props;
	const classes = useStyles();

	const getFontSizeAsPercent = (fontSize: number) => {
		return `${Math.floor((fontSize / 20) * 100)}%`;
	};

	return (
		<AppBar position="static" className={classes.appBar}>
			<Toolbar>
				<IconButton color="inherit" aria-label="Open drawer" onClick={onGoBack}>
					<ArrowBack />
				</IconButton>
				<Hidden mdUp>
					<div className={classes.hiddenTitleContainerMdUp}>
						<Typography variant="h6" className={classes.title} color="inherit">
							{title}
						</Typography>
					</div>
				</Hidden>
				<Hidden mdDown>
					<div className={classes.hiddenTitleContainerMdDown}>
						<Typography variant="h6" className={classes.title} color="inherit">
							{title}
						</Typography>
					</div>
				</Hidden>
				<div className={classes.grow} />
				<Grid container justifyContent="flex-end" className={classes.popOverContainer}>
					<Grid item className={classes.mr15}>
						<IconButton onClick={(e) => setAnchorElFont(e.currentTarget)} color="inherit">
							<ZoomInIcon />
						</IconButton>
						<Popover
							id="simple-popper"
							open={Boolean(anchorElFont)}
							anchorEl={anchorElFont}
							onClose={() => setAnchorElFont(undefined)}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "center",
							}}
						>
							<div className={classes.fontSizingWrapper}>
								<IconButton className={classes.buttonIcon} onClick={(e) => decreaseFontSize(e)}>
									<RemoveIcon fontSize="small" />
								</IconButton>
								<Typography className={classes.fontPrecentage}>{getFontSizeAsPercent(fontSize)}</Typography>
								<IconButton className={classes.buttonIcon} onClick={(e) => increaseFontSize(e)}>
									<AddIcon fontSize="small" />
								</IconButton>
							</div>
						</Popover>
					</Grid>
					<Grid item>
						<UserAvatar />
					</Grid>
				</Grid>
			</Toolbar>
		</AppBar>
	);
}